import { Routes } from '@angular/router';
import { Error500Component } from './error-500/error-500.component';
import { ERROR_500 } from './final-pages.constants';



export const finalPagesChildrenRoutes: Routes = [

  { path: ERROR_500, component: Error500Component }
];
